export default "__VITE_ASSET__d7016f5b__$_?react__"